import React from 'react';
import { FIRST_VIEW, SCHEDULE_LINE, WHO_READY_GREEN_GRADIENT } from './content';
import styles from './ScheduleBanner.module.css';

const TONE_CLASS = {
  year: styles.year,
  neutral: styles.neutral,
  accent: styles.accent,
  location: styles.location,
};

// フライヤー準拠の日程帯（2026.9.24.THU - 9.27.SUN @TOKYO）。
export default function ScheduleBanner({ className, compact = false }) {
  return (
    <div
      className={[styles.wrapper, compact && styles.compact, className]
        .filter(Boolean)
        .join(' ')}
      style={{
        '--raid-green-from': WHO_READY_GREEN_GRADIENT.from,
        '--raid-green-to': WHO_READY_GREEN_GRADIENT.to,
      }}
    >
      <div className={styles.ruleSolid} aria-hidden="true" />
      <p className={styles.banner}>
        <span className="sr-only">{FIRST_VIEW.schedule}</span>
        {SCHEDULE_LINE.map(({ text, tone }, index) => (
          <span
            key={`${index}-${tone}-${text}`}
            className={TONE_CLASS[tone]}
            aria-hidden="true"
          >
            {text}
          </span>
        ))}
      </p>
      <div className={styles.ruleSolid} aria-hidden="true" />
    </div>
  );
}
